import SubCategoriesTable from './SubCategoriesTable';

export default SubCategoriesTable;
